module.exports = __webpack_public_path__ + "static/media/mars-double.94d2759c.svg";